export * from "@/ui/components/layout/Article/Article";
export * from "@/ui/components/layout/Article/Article.config";
